var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { ChipInputComponent } from "./ChipInputComponent";
import TextField from "@material-ui/core/TextField";
export var ChipTextField = React.forwardRef(function ChipTextField(_a, ref) {
    var _b = _a.InputProps, _c = _b === void 0 ? {} : _b, InputProps = __rest(_c, []), _d = _a.inputProps, _e = _d === void 0 ? {} : _d, inputProps = __rest(_e, []), _f = _a.InputLabelProps, _g = _f === void 0 ? {} : _f, InputLabelProps = __rest(_g, []), chips = _a.chips, props = __rest(_a, ["InputProps", "inputProps", "InputLabelProps", "chips"]);
    return (React.createElement(TextField, __assign({ InputProps: __assign({ inputComponent: ChipInputComponent }, InputProps), inputProps: __assign({ chips: chips }, inputProps), InputLabelProps: __assign({ shrink: !!(Array.isArray(chips) ? chips.length : chips) || undefined }, InputLabelProps) }, props, { ref: ref })));
});
//# sourceMappingURL=ChipTextField.js.map